import * as z from "zod";

const GeneratedPromptSchema_ = z.object({ id: z.string(), text: z.string() });

export const GeneratedPromptSchema: z.ZodType<GeneratedPromptSchema> =
  GeneratedPromptSchema_;
export interface GeneratedPromptSchema
  extends z.infer<typeof GeneratedPromptSchema_> {}

export const generateAeoPrompts = {
  name: "generateAeoPrompts" as const,
  input: z.object({
    description: z.string().min(1).max(1000),
    // Client-side prompts to exclude (e.g., already displayed but unsaved)
    excludePrompts: z.array(z.string()).optional(),
  }),
  output: z.array(GeneratedPromptSchema),
};
